export default "https://cdn.questicon.mathletics.com/assets/images/CloudSoftNarrow-77000267f80761b1eb8ce425f269596d.png";